// This file was automatically generated from appshared.dialog.editPatient.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appshared.dialog.editPatient');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appshared.dialog.patientForm');
goog.require('el8.template.ptdata.patients');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.editPatient.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form id="edit-patient-form" class="ebs-form-horizontal" style=\'padding-bottom:200px;\' autocomplete="off"><div class="elig-section el8NotificationCaution m10 pad15" style="display: none"></div>');
  el8.template.appshared.dialog.patientForm.contents(opt_data, output);
  output.append('</form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.editPatient.eligibilityNotice = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h4 class="noBorder el8Bold padb10 mv0">Verify patient information to download medication history and check for medication coverage eligibility.</h4><p class="el8AppText padb10">Double-check the following fields: <span class="el8Bold">First Name, Middle Name, Last Name, Sex, DOB, Zip Code</span> to confirm that they match the information on the patient\'s insurance card.</p>', (opt_data.failureReason) ? '<div class="elig-failure-reason"><p class="el8AttentionText el8Bold">' + soy.$$escapeHtml(opt_data.failureReason) + '</p></div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.dialog.editPatient.longTitle = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('Confirm Patient Details for: ');
  el8.template.ptdata.patients.fullName(opt_data, output);
  output.append(' (', (soy.$$escapeHtml(opt_data.dob)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.dob)) : ''), ')');
  if (!opt_sb) return output.toString();
};
